import React, { useCallback, useState } from 'react';

import { Helmet } from 'react-helmet';
import { useHistory, useLocation } from 'react-router-dom';

import { Container, Tab, Tabs } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';

import { type IAppName } from '~/services/AwsJobsService';

import AwsJobsPageContainer from './PageContainer';
import { DERBYSOFT_TYPE, PUBLIC_OFFERS_TYPE } from './constants';

function AwsJobsPage() {
  const history = useHistory();
  const location = useLocation();

  const getInitialTab = useCallback(() => {
    const hash = location.hash.replace('#', '');
    return (hash || PUBLIC_OFFERS_TYPE) as IAppName;
  }, [location.hash]);

  const [selectedTab, setSelectedTab] = useState<IAppName>(getInitialTab);

  const handleTabChange = useCallback(
    (_, value) => {
      setSelectedTab(value);

      history.replace({
        pathname: location.pathname,
        search: value !== PUBLIC_OFFERS_TYPE ? location.search : '',
        hash: value,
      });
    },
    [history, location.pathname, location.search],
  );

  return (
    <>
      <Container maxWidth="xl">
        <Helmet>
          <title>AWS Jobs</title>
        </Helmet>
        <PageHeader title="AWS Jobs" />
        <Tabs sx={{ mb: 2 }} value={selectedTab} onChange={handleTabChange}>
          <Tab key={PUBLIC_OFFERS_TYPE} value={PUBLIC_OFFERS_TYPE} label="Public Offers" />
          <Tab key={DERBYSOFT_TYPE} value={DERBYSOFT_TYPE} label="Derbysoft" />
        </Tabs>

        <AwsJobsPageContainer selectedTab={selectedTab} />
      </Container>
    </>
  );
}

export default AwsJobsPage;
